export default "__VITE_ASSET__BZOG1zE5__"